module.exports = __webpack_public_path__ + "static/nonviolent-communication-a-language-of-life-9c826dcc19fa1aa39a6924ef315ad379.jpg";